import React from 'react'
import './index.scss'
import Button from '@App/kit/components/Buttons/Button'
import { observer } from 'mobx-react'
import MatchingStore from '@App/stores/rightsholder/match/matching-store'

interface MatchConfirmationProps {
    goToStep: (step: number) => void
    matchingStore: MatchingStore
}

const MatchConfirmation = ({ goToStep, matchingStore }: MatchConfirmationProps) => {
    const recordingCount = matchingStore.selectedUnmatchedRecordingGroupsLength
    return (
        <div className="global-container">
            <div className="match-confirmation-wrapper">
                <div className="match-confirmation">
                    <div className="match-confirmation-head">
                        <h2>
                            {recordingCount} Recording Groups{' '}
                            <span className="unbold">are pending usage match to the work </span>
                            {matchingStore.selectedWorkTitle}.
                        </h2>
                        <p>
                            Congratulations! You&apos;ve matched recordings to your work. This match is now under review
                            by our team. You can check its status by visiting the Match History tab in your Portal
                            account navigation bar.
                        </p>
                    </div>
                    <div className="bottom-nav">
                        <Button
                            mainColor
                            type="primary"
                            onClick={() => {
                                matchingStore.clearSelectedUnmatchedRecordingGroups()
                                goToStep(1)
                            }}
                        >
                            Done
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default observer(MatchConfirmation)
